import { SettingsPage } from "@client/features/settings/SettingsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/ustawienia")({
  component: SettingsPage,
});
